import { RAW_COLORS } from '../colors';

export const INPUT_THEME = {
  color: {
    bg: {
      normal: RAW_COLORS.white,
      disabled: RAW_COLORS.bluegray100,
    },
    border: {
      normal: RAW_COLORS.bluegray200,
      active: RAW_COLORS.blue700,
      error: RAW_COLORS.red600,
      hover: RAW_COLORS.bluegray300,
      disabled: RAW_COLORS.bluegray200,
    },
  },
};